import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import configuration from '../config';
import useLocalStorage from '../hooks/useLocalStorage';

const initialState = {
  ...configuration,
  onChangeContainer: () => {},
  onChangeLocalization: () => {},
  onChangeMode: () => {},
  onChangePresetColor: () => {},
  onChangeDirection: () => {},
  onChangeMiniDrawer: () => {},
  onChangeMenuOrientation: () => {},
  onChangeFontFamily: () => {},
};

const ConfigContext = createContext(initialState);

function ConfigProvider({ children }) {
  const [config, setConfig] = useLocalStorage(
    'mantis-react-js-config',
    initialState,
  );

  const onChangeContainer = () => {
    setConfig({
      ...config,
      container: !config.container,
    });
  };

  const onChangeLocalization = lang => {
    setConfig({
      ...config,
      i18n: lang,
    });
  };

  const onChangeMode = mode => {
    setConfig({
      ...config,
      mode,
    });
  };

  const onChangePresetColor = theme => {
    setConfig({
      ...config,
      presetColor: theme,
    });
  };

  const onChangeDirection = direction => {
    setConfig({
      ...config,
      themeDirection: direction,
    });
  };

  const onChangeMiniDrawer = miniDrawer => {
    setConfig({
      ...config,
      miniDrawer,
    });
  };

  const onChangeMenuOrientation = layout => {
    setConfig({
      ...config,
      menuOrientation: layout,
    });
  };

  const onChangeFontFamily = fontFamily => {
    setConfig({
      ...config,
      fontFamily,
    });
  };

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = {
    ...config,
    onChangeContainer,
    onChangeLocalization,
    onChangeMode,
    onChangePresetColor,
    onChangeDirection,
    onChangeMiniDrawer,
    onChangeMenuOrientation,
    onChangeFontFamily,
  };

  return (
    <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>
  );
}

ConfigProvider.propTypes = {
  children: PropTypes.node,
};

export { ConfigProvider, ConfigContext };
